import { render, staticRenderFns } from "./lf-search.vue?vue&type=template&id=36c10d04&scoped=true"
import script from "./lf-search.ts?vue&type=script&lang=ts&external"
export * from "./lf-search.ts?vue&type=script&lang=ts&external"
import style0 from "./lf-search.less?vue&type=style&index=0&id=36c10d04&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c10d04",
  null
  
)

export default component.exports